import { Phone, Video, MoreVertical, ArrowLeft } from "lucide-react";

/**
 * StaticPhone — used in Hero, shows a few preset bubbles to sell the idea
 */
const StaticPhone = () => {
  return (
    <div className="relative" data-testid="hero-phone-mockup">
      {/* Floating decorations */}
      <div
        className="absolute -top-6 -left-6 w-24 h-24 rounded-full blur-2xl opacity-50"
        style={{ background: "#25D366" }}
      />
      <div
        className="absolute -bottom-8 -right-4 w-32 h-32 rounded-full blur-3xl opacity-30"
        style={{ background: "#A7F3D0" }}
      />

      {/* Phone frame */}
      <div className="relative mx-auto w-[300px] sm:w-[340px] aspect-[9/19] rounded-[44px] bg-[#0e1311] p-3 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.45)] border border-black/40">
        {/* notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-28 h-6 bg-black rounded-full z-20" />

        <div className="relative w-full h-full rounded-[34px] overflow-hidden bg-white flex flex-col">
          {/* WhatsApp header */}
          <div className="bg-[#075E54] text-white px-4 pt-8 pb-3 flex items-center gap-3">
            <ArrowLeft className="w-5 h-5 opacity-80" />
            <div className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-base font-semibold">
              PÉ
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm leading-tight truncate">
                Plan Étude
              </div>
              <div className="text-[11px] text-white/70 flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] pulse-dot inline-block" />
                en ligne
              </div>
            </div>
            <Video className="w-5 h-5 opacity-80" />
            <Phone className="w-4 h-4 opacity-80" />
            <MoreVertical className="w-4 h-4 opacity-80" />
          </div>

          {/* Chat */}
          <div className="flex-1 wa-bg px-3 py-4 flex flex-col gap-2 overflow-hidden">
            <div className="self-center text-[10px] bg-[#E1F2FB] text-[#54656F] rounded-md px-2 py-1 mb-1">
              Aujourd'hui
            </div>

            <div className="self-start max-w-[80%] bg-white rounded-2xl rounded-tl-sm px-3 py-2 text-[13px] text-gray-800 shadow-sm">
              👋 Petit rappel : tu t'étais engagée à étudier 30 minutes entre
              17 h et 18 h aujourd'hui.
              <div className="text-[10px] text-gray-400 text-right mt-1">
                17:00
              </div>
            </div>
            <div className="self-start max-w-[80%] bg-white rounded-2xl rounded-tl-sm px-3 py-2 text-[13px] text-gray-800 shadow-sm">
              Veux-tu commencer maintenant ?
              <div className="text-[10px] text-gray-400 text-right mt-1">
                17:00
              </div>
            </div>
            <div className="self-end max-w-[80%] bg-[#DCF8C6] rounded-2xl rounded-tr-sm px-3 py-2 text-[13px] text-gray-800 shadow-sm">
              Oui je commence ! 📚
              <div className="text-[10px] text-gray-500 text-right mt-1">
                17:01 ✓✓
              </div>
            </div>
            <div className="self-end max-w-[80%] bg-[#DCF8C6] rounded-2xl rounded-tr-sm px-3 py-2 text-[13px] text-gray-800 shadow-sm">
              J'ai terminé 35 min – Mathématiques
              <div className="text-[10px] text-gray-500 text-right mt-1">
                17:36 ✓✓
              </div>
            </div>
            <div className="self-start max-w-[80%] bg-white rounded-2xl rounded-tl-sm px-3 py-2 text-[13px] text-gray-800 shadow-sm">
              Bravo Léa 🎉 Rapport envoyé à ton parent ce soir.
              <div className="text-[10px] text-gray-400 text-right mt-1">
                17:36
              </div>
            </div>
          </div>

          {/* Input bar */}
          <div className="bg-[#F0F2F5] px-3 py-2 flex items-center gap-2">
            <div className="flex-1 bg-white rounded-full px-3 py-1.5 text-xs text-gray-400">
              Message
            </div>
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center"
              style={{ background: "#25D366" }}
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white">
                <path d="M2 21l21-9L2 3v7l15 2-15 2z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticPhone;
